import React, { useState, useEffect } from 'react';

const Navigation = () => {
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);
  const [isMobile, setIsMobile] = useState(false);

  useEffect(() => {
    const checkIfMobile = () => {
      const mobile = window.innerWidth < 768;
      setIsMobile(mobile);
      if (!mobile) setIsMobileMenuOpen(false);
    };

    checkIfMobile();
    window.addEventListener('resize', checkIfMobile);

    return () => window.removeEventListener('resize', checkIfMobile);
  }, []);

  const toggleMobileMenu = () => {
    setIsMobileMenuOpen(!isMobileMenuOpen);
  };

  const getNavbarCollapseClass = () => {
    if (isMobile) {
      return `w-full overflow-hidden transition-all duration-300 ease-in-out ${
        isMobileMenuOpen ? 'max-h-[500px] opacity-100' : 'max-h-0 opacity-0'
      }`;
    }
    return 'flex w-auto max-h-[48px] opacity-100';
  };

  const getToggleClass = () => {
    return (
      "md:hidden flex flex-col justify-center items-center " +
      "relative cursor-pointer mr-[15px] h-[30px] ml-[15px] mt-[8px] mb-[8px] " +
      "py-0 px-[10px] border border-[#333] rounded text-white " +
      "focus:bg-[#333] focus:outline focus:outline-[5px] focus:outline-[#5bc0ff] focus:outline-offset-[-2px]"
    );
  };

   // Hàm xác định class cho menu item
  const getMenuItemClass = (path) => {
    const currentPath = window.location.pathname;
    const isActive =
      currentPath === path ||
      (path === '/home' && (currentPath === '/' || currentPath === '/home'));
    if (isActive) {
      // Active: trắng, nền xanh đậm, không hover/focus
      return 'block py-[14px] px-[15px] bg-[#02203e] text-white text-[14px] font-normal no-underline hover:text-white hover:no-underline focus:no-underline';
    }
    // Không active: vàng, có hover/focus
    return 'block py-[14px] px-[15px] text-[#fbbf24] text-[14px] font-normal no-underline hover:text-white hover:no-underline focus:no-underline transition-colors duration-150';
  };

  return (
    <nav className="bg-[#003468] border-[1px] border-[#002b56] w-full mb-0">
      <div className="max-w-full md:mx-auto mx-0 px-0">
        <div className="flex flex-col md:flex-row items-center md:items-center justify-start px-0 h-auto relative">
          {/* Brand & Toggle */}
          <div className="flex items-center justify-between w-full md:w-auto md:mx-0 md:px-4 px-0">
            <a
              className="text-[#fbbf24] text-[18px] leading-8 flex items-center font-normal no-underline hover:text-white hover:no-underline focus:no-underline md:-ml-[15px] -ml-[10px] px-6 py-[14px]"
              href="http://pnj.com.vn/"
            >
              Trang chủ PNJ
            </a>
            <button
              type="button"
              className={getToggleClass()}
              aria-expanded={isMobileMenuOpen}
              onClick={toggleMobileMenu}
              style={{ display: isMobile ? "flex" : "none" }}
            >
              <span className="sr-only">Toggle navigation</span>
              <span className="block w-[22px] h-[2px] rounded bg-white"></span>
              <span className="block w-[22px] h-[2px] rounded bg-white mt-[4px]"></span>
              <span className="block w-[22px] h-[2px] rounded bg-white mt-[4px]"></span>
            </button> 
          </div>
          {/* Menu */}
          <div className={getNavbarCollapseClass()} id="mainNavbar">
            {(!isMobile || isMobileMenuOpen) && (
              <ul className="flex flex-col md:flex-row m-0 p-0 list-none">
                <li className="md:inline-block">
                  <a href="/home" className={getMenuItemClass("/home")}>
                    TRANG CHỦ
                  </a>
                </li>
                <li className="md:inline-block">
                  <a href="/contact" className={getMenuItemClass("/contact")}>
                    LIÊN HỆ
                  </a>
                </li>
              </ul>
            )}
          </div>
        </div>
      </div>
    </nav>
  );
};

export default Navigation;